import 'whatwg-fetch';
import { toQueryString } from '../utils/url';
import { IMPERSONATED_KEY, ID_TOKEN_KEY } from './authService';
// import pickBy from 'lodash.pickby';

export default function(auth, base=window.location.origin){
  // TODO - refactor these arguments to be a single hash, this is silly
  const APICall = function( endpoint, method='GET', body=null, query=null, options={}) {
    const { bypassToken } = options;
    const args = arguments;
    const retry = () => {
      return APICall.apply(this, args);
    };

    const parseResponse = (r) => {
      const contentType = r.headers.get('content-type');
      if(contentType && contentType.indexOf('application/json') === 0){
        let fallback = r.clone();
        return r.json()
          .catch(
            err => fallback.text()
              .then(
                body => {
                  // if the parsing error was just because the response was empty, ignore the error and return empty string
                  if(body === ''){
                    return body;
                  }
                  // else it's a real error, throw it
                  throw Error(err);
                }
              )
          );
      }
      return r.text();
    }

    const headers = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${auth.getToken()}`
    };
    const idToken = auth.getToken(ID_TOKEN_KEY);
    if(idToken){
      headers['X-ID-Token'] = idToken;
    }

    const origin = /^http/.test(endpoint)
      ? ''
      : base;

    return fetch(
      `${origin}${endpoint}${toQueryString(query)}`,
      {
        method,
        headers,
        body: body ? JSON.stringify(body) : undefined
      }
    )
    // pass down a boolean indicating if the response is ok, as well as the parsed response
    .then(response => {
      return Promise.all([
        new Promise(resolve => resolve(response.ok)),
        parseResponse(response)
      ]);
    })
    .then(([ok, body]) => {
      if(ok){
        return body;
      } else {
        throw body;
      }
    })
    .catch(err => {
      console.error(err);
      try {
        // jwt is malformed or not found, just logout
        if(err && err.status === 401 && err.message.match(/malformed|not found/ig)){
          if(typeof auth.logoutWithReentry === 'function'){
            auth.logoutWithReentry();
            return;
          }
        }

        // if we get a 401 with an expired message, then our token could be expired, so try to refresh it and retry
        if(
          err &&
          err.status === 401 &&
          (
            (err.message && /expired/ig.test(err.message)) ||
            (err.body && /expired/ig.test(JSON.stringify(err.body)))
          )
        ){
          if(auth.isImpersonated()){
            auth.logout({ impersonated: true });
            return;
          }
          return auth.renewAuth()
            .then(retry)
            .catch(
              err => {
                console.error(err);
                return auth.logoutWithReentry();
              }
            );
        }
      }
      catch(_){}
      throw err;
    });
  };
  return APICall;
}
